import React from "react";
import Button from "react-bootstrap/Button";
import Figure from "react-bootstrap/Figure";
//import Image from "react-bootstrap/Image";
//import Tooltip from "react-bootstrap/Tooltip";

function ItemChoiceItemDisplay(props) {
  return (
    <div>
      <Figure>
        <Figure.Image
          width={80}
          height={80}
          alt={props.item.name}
          src={require("../assets/".concat(props.item.image))}
          />
          <Figure.Caption>
            {props.item.name /*not sure if i want this caption*/}
            <div> {"Slot: ".concat(props.item.type)} </div>
            {
              props.item.attackRange &&
                <div> 
                  Att: {props.item.attackRange.min} - 
                  {props.item.attackRange.max} 
                </div>
            }
            {
              props.item.defense != null &&
                <div> Def: {props.item.defense} </div>
            }
            <Button 
              onClick={() => props.addToInventory(props.item)}
              disabled={!props.showItemChoiceModal}
            >
              Pick
            </Button>
          </Figure.Caption>
      </Figure>

    </div>
  );
}

export default ItemChoiceItemDisplay;
